import React, { useContext, useState } from 'react';
import classnames from 'classnames';
import { connectStateResults } from 'react-instantsearch-dom';
import { Typography, Icon } from 'ck-ui';
import { getImgixUrl } from 'ck-utils';
import { useMedia } from 'react-use';
import { AddBundleToCart } from './AddBundleToCart';
import { BundleLookPrice } from './BundleLookPrice';
import { BundleLookModalToggle } from './BundleLookModalToggle';
import { BundleLookPageContext } from '../context';
import styles from './BundleProgressBar.module.scss';

const BundleProgressBar = connectStateResults(({ isSearchStalled }) => {
  const { groups, onDeleteProduct, onChangeTag, selectedTag } = useContext(BundleLookPageContext);
  const [currentPosition, setCurrentPosition] = useState(0);
  const isWidescreen = useMedia('(min-width: 1440px)');

  return (
    <div className={styles.root}>
      <BundleLookModalToggle />
      {isWidescreen && (
        <div className={styles.details}>
          <div className="is-flex">
            {groups.map((group, groupPosition) => group.products.map((product, productPosition) => (
              product.imageUrl ? (
                <button
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${group.tag}_${productPosition}`}
                  style={{ backgroundImage: `url('${getImgixUrl(product.imageUrl)}')` }}
                  className={styles.product}
                  type="button"
                  onClick={() => onDeleteProduct(groupPosition, productPosition)}
                >
                  <Typography
                    className={classnames('is-flex-centered', 'is-full-width', 'is-full-height', 'is-hidden', styles.remove)}
                    uppercase
                    variant="heading10"
                    align="centered"
                    color="white"
                  >
                    <Icon name="cross" />
                    Remove
                  </Typography>
                </button>
              ) : (
                <button
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`${group.tag}_${productPosition}`}
                  type="button"
                  className={styles.product}
                  onClick={() => {
                    setCurrentPosition(productPosition);
                    if (onChangeTag) onChangeTag(group.tag);
                  }}
                >
                  <span className="is-flex-centered is-full-height">
                    <Icon name={group.icon} size="large" color="grey" />
                  </span>
                  <Typography
                    uppercase
                    color="black-bis"
                    variant="heading10"
                    align="centered"
                    className={styles.text}
                    loading={isSearchStalled && selectedTag === group.tag && currentPosition === productPosition}
                  >
                    <span className="icon icon-plus" />
                    <br />
                    <span>{group.name}</span>
                  </Typography>
                </button>
              )
            )))}
          </div>
          <BundleLookPrice />
        </div>
      )}
      <AddBundleToCart />
    </div>
  );
});

export { BundleProgressBar };
